export { PlanogramV2Service } from './planogram-v2.service';


// WEBPACK FOOTER //
// ./src/app/pages/cms/components/capsuline/planogram-v2/services/index.ts